import React from 'react';

export const CloseIcon = () => (
    <svg className="close-icon" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M7.75706 5.63599L5.63574 7.75731L9.87838 11.9999L5.63574 16.2426L7.75706 18.3639L11.9997 14.1213L16.2423 18.3639L18.3637 16.2426L14.121 11.9999L18.3637 7.75731L16.2423 5.63599L11.9997 9.87863L7.75706 5.63599Z"
          fill="white"/>
    </svg>
);
